import { Dropdown, MenuItem, mergeClassnames } from '@heathmont/moon-core-tw';
import useProto from '~/client/features/Proto/hooks/useProto';
import useLanguageSwitcher from './useLanguageSwitcher';

const languageCodeToTitleMapper: Record<LanguageCode, string> = {
  ar: 'العربية',
  de: 'Deutsch',
  en: 'English',
  es: 'Español',
  fi: 'Suomi',
  fr: 'Français',
  ja: '日本語',
  ko: '한국어',
  no: 'Norsk',
  pt: 'Português',
  th: 'ไทย',
  tr: 'Türkçe',
  vi: 'Tiếng Việt',
  zh: '中文',
};

type Props = {
  optionClassName?: string;
};

const LanguageSwitcher = ({ optionClassName }: Props) => {
  const { isProtoEnabled } = useProto();
  const { handleChange, languages, router } =
    useLanguageSwitcher(isProtoEnabled);

  return (
    <Dropdown
      data-testid="language-switcher"
      value={router.locale}
      onChange={handleChange}
    >
      {({ open }) => (
        <>
          <Dropdown.Select open={open} className="w-full [&_span]:text-trunks">
            {languageCodeToTitleMapper[router.locale]}
          </Dropdown.Select>
          <Dropdown.Options
            className={mergeClassnames('z-50', optionClassName)}
          >
            {languages.map((code) => (
              <Dropdown.Option value={code} key={code}>
                {({ selected, active }) => (
                  <MenuItem isActive={active} isSelected={selected}>
                    {languageCodeToTitleMapper[code]}
                  </MenuItem>
                )}
              </Dropdown.Option>
            ))}
          </Dropdown.Options>
        </>
      )}
    </Dropdown>
  );
};

export default LanguageSwitcher;
